// Saved website profiles (PF-19), the phone's side of when to offer one. A guest who came through our
// website is offered to save their profile once they have finished a round (on the results board,
// then now and again in the menu, never blocking play). Inside a distributor's frame (Lagos Life,
// and every store after it) none of this ever shows: the distributor owns that player's profile.
import { isFramed } from '@wahala/vatar-client';
import { useUi } from '../store/ui';

const ROUNDS = 'wahala.roundsDone';
const LATER = 'wahala.saveOffer.later';
/** After Not now, the menu asks again this much later. */
export const OFFER_AGAIN_MS = 3 * 86_400_000;

function read(key: string): number {
  try {
    return Number(localStorage.getItem(key)) || 0;
  } catch {
    return 0;
  }
}
function write(key: string, v: number): void {
  try {
    localStorage.setItem(key, String(v));
  } catch {
    // storage blocked: the offer just comes back sooner
  }
}

/** A round played to its end on this phone (a tutorial round doesn't count). */
export function markRoundDone(): void {
  write(ROUNDS, read(ROUNDS) + 1);
}
export const roundsDone = (): number => read(ROUNDS);

/** Not now: the menu leaves the offer alone for a few days (the profile screen still has it). */
export function sayLater(now = Date.now()): void {
  write(LATER, now);
}
const saidLaterRecently = (now: number): boolean => now - read(LATER) < OFFER_AGAIN_MS;

/**
 * May this phone offer to save a profile at all? Only outside any frame, only on a server that
 * serves standalone play with a way to send a code, and only to a website guest. Lagos Life's
 * players (account 'platform') never see it, framed or not.
 */
export function maySave(): boolean {
  const u = useUi.getState();
  if (isFramed()) return false;
  const a = u.config?.accounts;
  if (!u.config?.platforms?.standalone || !a || (!a.email && !a.phone)) return false;
  return u.account === 'guest';
}

/** The gentle offer: after a finished round, unless Not now was said lately. */
export function shouldOffer(now = Date.now()): boolean {
  return maySave() && roundsDone() > 0 && !saidLaterRecently(now);
}

/** Signing in with a saved profile: outside any frame, where standalone play is served. */
export function maySignIn(): boolean {
  const c = useUi.getState().config;
  return !isFramed() && Boolean(c?.platforms?.standalone && c.accounts && (c.accounts.email || c.accounts.phone));
}
